export default  {
    component: 'transformer',
    name: 'transformer',
    fields: [
        {
            param: 'plant_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            name: 'Block ID',
            param: 'block_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `> Should always start from ID **"1"**`
          },
          {
            name: 'Inverter Room',
            param: 'inverter_room',
            type: 'number',
            required: true,
            identifier: true,
            description: `> For each block, room id should start from **"1"**`
          },
          {
            name: 'Transformer ID',
            param: 'transformer_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `> For each block, transformer id should start from **"1"**`
          },
          {
            name: 'Device ID',
            param: 'device_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `Concatination of all the device ID's 1-1-1`
          },
          {
            name: 'Inverter List',
            param: 'inverter_list',
            type: 'text',
          },
          {
            name: 'Transformer Name',
            param: 'transformer_name',
            type: 'text',
            description: `> For each block device name should be unique`
          },
          {
            name: 'Name Config',
            param: 'name_config',
            type: 'text',
            description: `The name should be unique. Name Concatination of blockname-roomname-devicename`
          },
          {
            name: 'Latitude',
            param: 'latitude',
            type: 'number',
          },
          {
            name: 'Longitude',
            param: 'longitude',
            type: 'number',
          },
          {
            name: 'Param Config',
            param: 'param_config',
            type: 'json',
            description: `If their is more than 1 winding temperature need to add in json
            - JSON : e.g. [{"act_win_temp": {"count": 3, "nameMap": ["TRF-1 WTI-1", "TRF-1 WTI-2", "TRF-1 WTI-3", "TRF-1 WTI-3"], "multiple": true}}] `
          },
          {
            name: 'Parameter List',
            param: 'param_list',
            type: 'text',
            description: `In order to remove unwanted parameters from analytics. *\(e.g rm-act_win_temp)`
          },
          {
            name: 'Capacity',
            param: 'capacity',
            type: 'number',
          },
          {
            name: 'Make',
            param: 'make',
            type: 'text',
          },
          {
            name: 'Act Win Temp Count',
            param: 'act_win_temp_count',
            type: 'number',
            description: `Add the count`
          },
          {
            name: 'Wt Alarm Sp Count',
            param: 'wt_alarm_sp_count',
            type: 'number',
            description: `Add the count`
          },
          {
            name: 'Wt Trip Sp Count',
            param: 'wt_trip_sp_count',
            type: 'number',
            description: `Add the count`
          },
          {
            name: 'Reading frequency',
            param: 'reading_frequency',
            type: 'number',
            description: `It varies from plants few we recieve data at interval of 5 min so we need to add frequency as **"5"** in order to show connectivity in graph.`
          }
    ]
  }






